import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const apiKey =
  process.env.REACT_APP_ENVIRONMENT === "production"
    ? process.env.REACT_APP_PRODUCTION_TOKEN
    : process.env.REACT_APP_STAGING_TOKEN;

export const unifiedApi = createApi({
  keepUnusedDataFor: 3600,
  tagTypes: ["Vehicle", "Location"],
  baseQuery: fetchBaseQuery({
    reducerPath: "unifiedAPI",
    baseUrl:
      process.env.REACT_APP_ENVIRONMENT === "production"
        ? "https://app.production.zappyride.com"
        : "https://app.beta.zappyride.com",
    prepareHeaders: (headers) => {
      headers.set("X-Api-Key", apiKey);
      return headers;
    },
  }),
  endpoints: (build) => {
    return {
      getVehicle: build.query({
        query: ({ handle, postcode, dealerId }) => {
          return `vehicles/${handle.handle}?postcode=${postcode}&dealerId=${dealerId}&dealerName=${window.dealerName}&include_used_vehicles`;
        },
        providesTags: (_, __, { handle, postcode }) => [
          { type: "Vehicle", handle: handle.handle, postcode },
        ],
      }),
      getLocation: build.query({
        query: ({ postcode, dealerId }) =>
          `location?postcode=${postcode}&dealerId=${dealerId}&dealerName=${window.dealerName}`,
        providesTags: (_, __, { postcode }) => [{ type: "Location", postcode }],
      }),
    };
  },
});

export const { useGetVehicleQuery, useGetLocationQuery } = unifiedApi;
